<template>
<div class="chapter">
<div class="inner_page">
<p class="C117"><a id="page_vii">CONTENTS</a></p><a id="page_vii">
</a><p class="C118"><a id="page_vii"><em></em></a><em><a href="#/html/05_Preface#page_ix">Preface</a></em></p>
<p class="C119"><em><a href="#/html/06_Acknowledgments#page_xix">Acknowledgments</a></em></p>
<p class="C118"><a href="#/html/07_INTRODUCTION___US_Law_and_Religi#page_1">INTRODUCTION / US Law and Religion Today</a></p>
<p class="C118"><a href="#/html/08_ONE___Spiritual_Governance#page_19">ONE / Spiritual Governance</a></p>
<p class="C118"><span href="#/html/09_TWO___The_Chaplain#page_53" title="Link target outside of Sample">TWO / The Chaplain</span></p>
<p class="C118"><span href="#/html/10_THREE___Credentialing_Chaplains#page_99" title="Link target outside of Sample">THREE / Credentialing Chaplains</span></p>
<p class="C118"><span href="#/html/11_FOUR___Chaplains_and_the_Constit#page_139" title="Link target outside of Sample">FOUR / Chaplains and the Constitution</span></p>
<p class="C119"><span href="#/html/12_FIVE___A_Ministry_of_Presence#page_173" title="Link target outside of Sample">FIVE / A Ministry of Presence</span></p>
<p class="C118"><em><span href="#/html/13_Afterword#page_193" title="Link target outside of Sample">Afterword</span></em></p>
<p class="C118"><em><span href="#/html/14_Appendix__Armed_Forces_Chaplains#page_203" title="Link target outside of Sample">Appendix: Armed Forces Chaplains Board Endorsers</span></em></p>
<p class="C118"><em><span href="#/html/15_Notes#note" title="Link target outside of Sample">Notes</span></em></p>
<p class="C118"><em><span href="#/html/15_Selected_Bibliography#page_217" title="Link target outside of Sample">Selected Bibliography</span></em></p>
<p class="C118"><em><span href="#/html/16_Index#page_235" title="Link target outside of Sample">Index</span></em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_CONTENTS.vue?6f540aea